'use client';

import React from 'react';
import DesktopOfficeMap from './DesktopOfficeMap';
import MobileOfficeGrid from './MobileOfficeGrid';

const GlobalFootprint: React.FC = () => {
  return (
    <section
      id="global-footprint"
      className="w-full flex flex-col items-center gap-4 sm:gap-4 lg:gap-9 py-4 sm:py-6 lg:py-8 max-w-screen-2xl mx-auto overflow-hidden sm:px-6 lg:px-8"
    >
      <h2 className="font-ibm-plex font-medium leading-tight text-2xl sm:text-3xl md:text-4xl lg:text-[40px] text-[#02435D] text-center w-full">
        Our Global Footprint
      </h2>

      <DesktopOfficeMap />
      <MobileOfficeGrid />
    </section>
  );
};

export default GlobalFootprint;
